module.exports = __webpack_public_path__ + "logo.png?16ffa037e7e1aae7e12c656473fd3e75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 20
// module chunks = 0